var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');
var OasisServices = require("../../data/oasis-services");

var OasisServicesValidatesView = Marionette.View.extend({
    template: require('../../templates/oasis/oasis-services-validates-view.html'),

    regions: {},

    ui: {
        modal: '#validates-modal'
    },

    events: {},

    childViewEvents: {},

    templateContext: function () {
        var that = this;
        return {
            oasisServices: that.oasisServices,
            documents: that.documents
        }
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        that.oasisServicesIds = options.oasisServicesIds;
        that.oasisServicesIds.sort();
        that.documents = _.sortBy(options.documents || [], "name");
        that.oasisServices = that.oasisServicesIds.map(function (id) {
            return OasisServices.getServiceById(id)
        });
    },

    onRender: function () {
        var that = this;
        that.show();
        $(function () {
            that.startValidatingCalls();
        });
    },

    startValidatingCalls: function () {
        var that = this;
        that.documents.forEach(function (doc) {
            that.oasisServices.forEach(function (service) {
                that.showLoader(doc.id, service.id);
            })
        });

        var documentContentGetCalls = that.documents.map(function (document) {
            return $.ajax({
                type: "GET",
                url: '/api/document/view/' + document.id
            })
        });
        $.when.apply(undefined, documentContentGetCalls).then(function () {
            var responses = arguments;
            if (documentContentGetCalls.length == 1) {
                responses = {0: responses};
            }

            _.keys(responses).forEach(function (respKey, index) {
                var documentId = that.documents[index].id;
                var documentName = that.documents[index].name;
                var oasisFileContent = responses[respKey][0];
                that.callOasisServices(documentId, documentName, oasisFileContent, that.oasisServices);
            });
        });
    },

    callOasisServices: function (docId, documentName, oasisContent, oasisServices) {
        var that = this;
        oasisServices.forEach(function (service) {
            var elementIdForResult = '#' + docId + "-" + service.id + "-results";
            if (service.id == 'pps-grouper' || service.id == "vut") {

                $.ajax({
                    type: "POST",
                    url: service.url,
                    data: oasisContent,
                    contentType: 'text/xml',
                    statusCode: {
                        200: function (response) {

                            if (service.id == "vut") {
                                that.renderVutResults($(elementIdForResult), response.results);
                            } else if (service.id == 'pps-grouper') {
                                that.renderPpsGrouperResults($(elementIdForResult), response);
                            } else {
                                $(elementIdForResult).text(JSON.stringify(response, null, '\t'));
                                $(elementIdForResult).css("color", "black");
                            }

                            that.hideLoader(docId, service.id);
                        }
                    },
                    error: function (e) {
                        if (e.status == 400) {
                            $(elementIdForResult).css("color", "red");
                        } else {
                            $(elementIdForResult).css("color", "yellow");
                        }
                        $(elementIdForResult).text(e.responseJSON.errorText);
                        that.hideLoader(docId, service.id);
                    }
                });
            } else if (service.id == 'pps-plus') {

                $.ajax({
                    type: "POST",
                    url: service.url,
                    data: oasisContent,
                    contentType: "text/xml",
                    xhrFields: {
                        responseType: 'blob'
                    },
                    statusCode: {
                        200: function (response) {

                            var blob = new Blob([response], {type: "application/pdf"});
                            var blobAsFile = window.URL.createObjectURL(blob);

                            var linkToViewPdf = document.createElement('a');
                            linkToViewPdf.href = blobAsFile;
                            linkToViewPdf.target = '_blank';
                            linkToViewPdf.setAttribute('view', documentName + '-pps-plus-validating-result.pdf');
                            linkToViewPdf.appendChild(document.createTextNode("View PPS-PLUS validating result (PDF)"));
                            $(elementIdForResult).append(linkToViewPdf);

                            $(elementIdForResult).append(document.createElement('br'));

                            var linkToDownloadPdf = document.createElement('a');
                            linkToDownloadPdf.href = blobAsFile;
                            linkToDownloadPdf.target = '_blank';
                            linkToDownloadPdf.setAttribute('download', documentName + '-pps-plus-validating-result.pdf');
                            linkToDownloadPdf.appendChild(document.createTextNode("Download PPS-PLUS validating result (PDF)"));
                            $(elementIdForResult).append(linkToDownloadPdf);

                            that.hideLoader(docId, service.id);
                        }
                    },
                    error: function (e) {
                        if (e.status == 400) {
                            $(elementIdForResult).css("color", "red");
                        } else {
                            $(elementIdForResult).css("color", "yellow");
                        }
                        $(elementIdForResult).text(JSON.stringify(e.responseJSON, null, '\t'));
                        that.hideLoader(docId, service.id);
                    }
                });

            } else {
                $(elementIdForResult).text(oasisContent);
                that.hideLoader(docId, service.id);
            }
        });
    },

    renderVutResults: function (parent, results) {
        var tableStart = '<table class="table table-hover">\n' +
            '            <thead>\n' +
            '            <tr>\n' +
            '                <th>No.</th>\n' +
            '                <th>Severity</th>\n' +
            '                <th>Text</th>\n' +
            '                <th>Item</th>\n' +
            '            </tr>\n' +
            '            </thead>\n' +
            '            <tbody>';
        var tableEnd = '</tbody>\n' +
            '        </table>';

        var trs = '';

        results.forEach(function (item) {
            var tr = '<tr><td>' + item.messageNumber + '</td><td>' + item.severity + '</td><td>' + item.text + '</td><td>' + item.item.replace('^', '') + '</td></tr>';
            trs = trs + tr;
        });
        parent.html(tableStart + trs + tableEnd);
    },

    renderPpsGrouperResults: function (parent, results) {
        var caption = '<div><b>Scoring result - </b>' + '<span class="label label-primary">' + results.validityFlagDescription + '</span>' + '</div>';
        var table = '<table class="table table-hover"><tbody>' + results.validationEdits.map(function (ve) {
            return '<tr><td>' + ve.oasisDataItem + '</td><td>' + ve.description + '</td></tr>';
        }).join('') + '</tbody></table>';

        parent.append(caption);
        if (results.validationEdits.length > 0) {
            parent.append("<br>");
            parent.append(table);
        }
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    showLoader: function (docId, serviceId) {
        $('#' + docId + "-" + serviceId + "-results").hide();
        $('#' + docId + "-" + serviceId + "-loader").show();
    },

    hideLoader: function (docId, serviceId) {
        $('#' + docId + "-" + serviceId + "-results").show();
        $('#' + docId + "-" + serviceId + "-loader").hide();
    }
});

module.exports = OasisServicesValidatesView;


//////////////////
// WEBPACK FOOTER
// ./app/views/oasis/oasis-services-validates-view.js
// module id = 366
// module chunks = 0